import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { API_URL } from './apiconfig';
import { HttpHeader } from '../core/httpheader';
import { CSPReport } from '../core/cspreport.model'
import { TxtAttach } from '../core/index.model';

@Injectable()
export class CSPReportService {
    private apiUrl: string;

    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(private http: Http) {
        this.apiUrl = API_URL;
    }

    GetCSPReportsList(JurisID: number) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this.http
            .get(this.apiUrl + '/Reports/GetCSPAllReportsName/' + JurisID, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => response.json() as CSPReport)
            .catch(this.handleError);
    }

    GetPDFCSPReport(CSPReportID: string, JurisID: number) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this.http.get(this.apiUrl + '/Reports/GetCSPReports/' + CSPReportID + "/" + JurisID, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => response.json() as TxtAttach)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/cspreport.service.ts